import { render, staticRenderFns } from "./CalendarDateInput.vue?vue&type=template&id=3a2d56bd&"
import script from "./CalendarDateInput.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarDateInput.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports